import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import rxnt from "../../../images/portfolio/rxnt.webp";
import frank from "../../../images/portfolio/frank.webp";
import svhs from "../../../images/portfolio/svhs.webp";
import tds from "../../../images/portfolio/tds.webp";
import tynax from "../../../images/portfolio/tynax.webp";
import anatomie from "../../../images/portfolio/anatomie.webp";
import vacsewcenter from "../../../images/portfolio/vacsewcenter.webp";
import westBoca from "../../../images/portfolio/wbes.webp";
import openn from "../../../images/portfolio/openn.webp";
import willship from "../../../images/portfolio/willship.webp";

import rxntLogo from "../../../images/carousel/rxnt.svg";
import frankLogo from "../../../images/carousel/frank.svg";
import svhsLogo from "../../../images/carousel/svhs.svg";
import tdsLogo from "../../../images/carousel/tds-logo.svg";
import tynaxLogo from "../../../images/carousel/tynax.svg";
import anatomieLogo from "../../../images/carousel/anatomie.svg";
import vacsewcenterLogo from "../../../images/carousel/vacsew-center.svg";
import westBocaLogo from "../../../images/carousel/west-boca.svg";
import opennLogo from "../../../images/carousel/openn.svg";
import willshipLogo from "../../../images/carousel/willship.svg";


const portfolioData = [
    {
        name: "RXNT,USA",
        description:
            "A leader in healthcare technology solutions, RXNT is recognized on the annual Inc. Magazine list of 5000 Fastest-Growing Private Companies 2019, the most prestigious ranking of the nation’s fastest-growing private companies.",
        imgSrc: rxnt,
        logo: rxntLogo,
        detailLink: "/resources/portfolio/detail/rxnt",
    },
    {
        name: "Frank",
        description:
            "A company that helps businesses ensure that food safety compliance is done in a simple and straightforward way. Now touching over 500,000 meals per year in Australia.",
        imgSrc: frank,
        logo: frankLogo,
        detailLink: "/resources/portfolio/detail/frank",
    },
    {
        name: "Silicon Valley High School, USA",
        description:
            "Silicon Valley High School offers students enrolled in traditional high schools or homeschooling programs the opportunity to access innovative, relevant, and compelling online high school courses.",
        imgSrc: svhs,
        logo: svhsLogo,
        detailLink: "/resources/portfolio/detail/svhs",
    },
    {
        name: "TaxDataSystems, USA",
        description:
            "A web-based tax API serving major eCommerce websites since 2009. Joined Thomson Reuters in 2014, and maintain the broadest and deepest coverage of indirect tax content in 14,500 tax jurisdictions for more than 175 countries.",
        imgSrc: tds,
        logo: tdsLogo,
        detailLink: "/resources/portfolio/detail/tds",
    },
    {
        name: "Tynax",
        description:
            "At the forefront of global high-tech patent trading, Tynax operates a cutting-edge exchange boasting hundreds of thousands of patents.",
        imgSrc: tynax,
        logo: tynaxLogo,
        detailLink: "/resources/portfolio/detail/tynax",
    },
    {
        name: "ANATOMIE STYLE",
        description:
            "Founded by the visionary duo Kate and Shawn Boyer, Anatomie stands as a beacon of innovation in the realm of designer fashion.",
        imgSrc: anatomie,
        logo: anatomieLogo,
        detailLink: "/resources/portfolio/detail/anatomie",
    },
    {
        name: "VACSEWCENTER",
        description:
            "Vacsewcenter takes great pride in its vast inventory, offering a diverse selection of machines, parts, and supplies, including elusive and hard-to-find items.",
        imgSrc: vacsewcenter,
        logo: vacsewcenterLogo,
        detailLink: "/resources/portfolio/detail/vacsewcenter",
    },
    {
        name: "WBES",
        description:
            "As West Boca Raton’s local provider of premium office space, WBES is optimally suited toward fulfilling the needs of our clients. With the resources of one of Boca’s largest property owners we are able to hire the most professional staff, offer the most luxurious furnishings and operate in a facility of the highest caliber.",
        imgSrc: westBoca,
        logo: westBocaLogo,
        detailLink: "/resources/portfolio/detail/wbes",
    },
    {
        name: "Openn, Australia",
        description:
            "Openn Negotiation is a transparent sales method which helps Buyers and Sellers find the true market price for a property, through an online bidding platform.",
        imgSrc: openn,
        logo: opennLogo,
        detailLink: "/resources/portfolio/detail/openn",
    },
    {
        name: "Willship International, Australia.",
        description:
            "Willship is the amalgamation of two specialized freight forwarders - one focussed on international automotive freight, the other in general freight. The result is a team with over 100 years industry experience and an expertise in all elements of international shipping.",
        imgSrc: willship,
        logo: willshipLogo,
        detailLink: "/resources/portfolio/detail/willship",
    },
];

const PortfolioCards = () => {

    const navigate = useNavigate()
    const handlePageLink = (path) => {
        navigate(path);
    }

    return (
        <section className="bg-grey py-4">
            <Container>
                <Row>
                    <Col xs="12" className="text-center">
                        <h3 className="text-primary ft-wt-700 mb-4">Portfolio</h3>
                    </Col>
                    {portfolioData.map((item, index) => {
                        // Determine the order classes based on the index for large screens
                        const isEven = index % 2 === 0;
                        const contentOrder = isEven
                            ? "order-2 order-lg-1"
                            : "order-2 order-lg-2";
                        const imageOrder = isEven
                            ? "order-1 order-lg-2"
                            : "order-1 order-lg-1";

                        return (
                            <Col key={index} xs={12}>
                                <Card className="mb-5">
                                    <Row className="no-gutters portfolio-cards">
                                        <Col xs={12} lg={6} className={imageOrder}>
                                            <Card.Img
                                                src={item.imgSrc}
                                                className="img-fluid portfolio-card-img"
                                                alt={item.name}
                                            />
                                        </Col>
                                        <Col xs={12} lg={6} className={contentOrder}>
                                            <Card.Body>
                                                <img
                                                    className="business-brands img-fluid"
                                                    src={item.logo}
                                                    alt={item.name}
                                                />
                                                <h3 className="text-primary ft-wt-700">{item.name}</h3>
                                                <Card.Text className="text-primary">
                                                    {item.description}
                                                </Card.Text>
                                                <Row>
                                                    <Col xs={12} sm="auto">
                                                        <Button variant="primary" onClick={() =>
                                                            handlePageLink(item.detailLink)
                                                        }>
                                                            VIEW MORE
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </Container>
        </section>
    );
};

export default PortfolioCards;
